define.alias("shared/components/shared/suggestion-text-area", "auth/components/shared/suggestion-text-area");